/**
 * 异步获取指定用户的基本信息。
 *
 * @param {number | string} id - 要获取用户信息的唯一标识符，可以是数字或字符串。
 * @returns {Promise<User.BasicInfo>} 包含用户基本信息的 Promise。
 */
export async function fetchUserDetailById(
  id: number | string
): Promise<User.BasicInfo> {
  // 发起 HTTP GET 请求获取用户基本信息
  return http
    .get<User.BasicInfo>('/v1/user/get_user', {
      id: Number(id)
    })
    .then((res) => res.data)
}
